// extracted by mini-css-extract-plugin
module.exports = {"autoWithdrawalStyle":"withdrawal_autoWithdrawalStyle__8xxHZ","autoWithdrawalContainer":"withdrawal_autoWithdrawalContainer__23tQO"};